module.exports = __webpack_public_path__ + "a41a429e78ff4c29aada90f17784a574.svg";